import { useState, useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster, toast } from "sonner";
import { Play, X, Instagram, Mail, ChevronDown, Sparkles, Mountain, Eye, Gem, BookOpen } from "lucide-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Chapter6 from "./Chapter6";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Artwork data with user's actual images
const artworks = [
  {
    id: 1,
    title: "Luminous Essence",
    image: "https://customer-assets.emergentagent.com/job_f6a02c9c-52ab-425d-8aa9-c578caf1d34c/artifacts/y0hftn38_IMG_6273.jpeg",
    category: "Raw Stone",
    featured: true
  },
  {
    id: 2,
    title: "Ancestral Spirit",
    image: "https://customer-assets.emergentagent.com/job_f6a02c9c-52ab-425d-8aa9-c578caf1d34c/artifacts/chkdn0uw_IMG_0999.jpeg",
    category: "Carved Pendant",
    featured: false
  },
  {
    id: 3,
    title: "Verdant Dream",
    image: "https://customer-assets.emergentagent.com/job_f6a02c9c-52ab-425d-8aa9-c578caf1d34c/artifacts/s0zdilq1_IMG_1026.jpeg",
    category: "Translucent",
    featured: false
  },
  {
    id: 4,
    title: "Guardian Skull",
    image: "https://customer-assets.emergentagent.com/job_f6a02c9c-52ab-425d-8aa9-c578caf1d34c/artifacts/t1qrq7d9_IMG_1047.jpeg",
    category: "Mixed Media",
    featured: false
  },
  {
    id: 5,
    title: "Ocean Talisman",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/mau8ouof_IMG_5607_Original.jpeg",
    category: "Carved Pendant",
    featured: true
  },
  {
    id: 6,
    title: "Celestial Bi Disc",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/zxiv1d4i_IMG_9748.jpeg",
    category: "Illuminated",
    featured: false
  },
  {
    id: 7,
    title: "QuetzalCoyotle",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/wbppqfl5_IMG_5997.jpeg",
    category: "Feathered Coyote",
    featured: true
  },
  {
    id: 8,
    title: "Amethyst Ancestor",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/xfri932s_IMG_1022.jpeg",
    category: "Crystal Skull",
    featured: true
  },
  {
    id: 9,
    title: "Thunderbird Assembly",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/hkshdqd4_IMG_0933.jpeg",
    category: "Multi-Piece",
    featured: false
  },
  {
    id: 10,
    title: "Kitsune Mask",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/wxej2e2b_IMG_1023.jpeg",
    category: "Sculpture",
    featured: false
  },
  {
    id: 11,
    title: "Primordial Blade",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/fcs477vz_A46E0FED-1565-44CA-81C3-9C9FB4C3E42F.jpeg",
    category: "Raw Stone",
    featured: false
  },
  {
    id: 12,
    title: "Twin Seahorses",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/nndrwp9j_99396254-A66B-41AC-9FEB-68F70BC03E5E.jpeg",
    category: "Sculpture Pair",
    featured: true
  },
  {
    id: 13,
    title: "Philosophers Lantern",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/0xmcmbrx_IMG_2584.jpeg",
    category: "Illuminated Art",
    featured: true
  },
  {
    id: 14,
    title: "Jade Sphere",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/0o24t5bh_IMG_0241.jpeg",
    category: "Polished Stone",
    featured: false
  },
  {
    id: 15,
    title: "Temple Offering",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/m3fkihgt_IMG_1949.jpeg",
    category: "Carved Piece",
    featured: false
  },
  {
    id: 16,
    title: "Jade Bangles",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/ffdczan5_IMG_2277.jpeg",
    category: "Wearable Art",
    featured: false
  },
  {
    id: 17,
    title: "Carved Bangles",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/wzpbqia2_70C355E9-DCC2-4020-B566-D521DCEEBA5C.jpeg",
    category: "Wearable Art",
    featured: false
  },
  {
    id: 18,
    title: "Jade Sculpture",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/pi31krsu_IMG_0984.jpeg",
    category: "Sculpture",
    featured: false
  },
  {
    id: 19,
    title: "Jade Pendant",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/ys9gl7nf_IMG_0990.jpeg",
    category: "Pendant",
    featured: false
  },
  {
    id: 20,
    title: "Jade Pipe",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/p6itb5ya_IMG_1030.jpeg",
    category: "Pipe",
    featured: true
  },
  {
    id: 21,
    title: "Jade Knife",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/clgn261d_IMG_5649.jpeg",
    category: "Blade",
    featured: true
  },
  {
    id: 22,
    title: "QuetzalCoyotle Detail",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/yb8wys8j_IMG_2904.jpeg",
    category: "Feathered Coyote",
    featured: false
  },
  {
    id: 23,
    title: "QuetzalCoyotle II",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/qdb5ukve_IMG_2938.jpeg",
    category: "Feathered Coyote",
    featured: true
  },
  {
    id: 24,
    title: "QuetzalCoyotle III",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/sk71uhnj_IMG_4226.jpeg",
    category: "Feathered Coyote",
    featured: false
  },
  {
    id: 25,
    title: "Philosophers Lantern II",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/903jfqix_IMG_2562.jpeg",
    category: "Illuminated Art",
    featured: true
  },
  {
    id: 26,
    title: "Philosophers Lantern III",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/n9yqvx17_IMG_2566.jpeg",
    category: "Illuminated Art",
    featured: false
  },
  {
    id: 27,
    title: "Philosophers Lanterns Collection",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/c481g2i2_IMG_2565.jpeg",
    category: "Illuminated Art",
    featured: true
  },
  {
    id: 28,
    title: "Jade Slab Detail",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/0w3xkky1_IMG_3531.jpeg",
    category: "Raw Stone",
    featured: false
  },
  {
    id: 29,
    title: "Seahorse Pair",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/xzyj2mp1_B0D2C48B-A7A2-429C-BDD1-C5DF3121E614.jpeg",
    category: "Sculpture",
    featured: true
  },
  {
    id: 30,
    title: "Seahorse Pair II",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/pg5vcv5h_21A1E67B-BB09-4594-AF75-7AFDB5ED83F8.jpeg",
    category: "Sculpture",
    featured: false
  },
  {
    id: 31,
    title: "Sky Key Sculpture Detail",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/5ae6jwbb_IMG_5903.jpeg",
    category: "Sky Key",
    featured: true
  },
  {
    id: 32,
    title: "Jade Bowl Detail",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/eerumk1p_IMG_5902.heic",
    category: "Vessel",
    featured: false
  },
  {
    id: 33,
    title: "Death Portal Pendant",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/6hrwp0gv_IMG_5899.jpeg",
    category: "Pendant",
    featured: true
  },
  {
    id: 34,
    title: "Sky Key",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/zv13wif8_IMG_5904.jpeg",
    category: "Sky Key",
    featured: true
  },
  {
    id: 35,
    title: "Illuminated Jade Bowl",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/0du2irin_IMG_5905.jpeg",
    category: "Illuminated Art",
    featured: true
  },
  {
    id: 36,
    title: "White Marble Lamp",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/pbsrqngm_IMG_5906.jpeg",
    category: "Illuminated Art",
    featured: true
  },
  {
    id: 37,
    title: "Jade Skull",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/202cuqoq_IMG_1017.jpeg",
    category: "Sculpture",
    featured: false
  },
  {
    id: 38,
    title: "Crystal Skull II",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/2x0150rc_IMG_1019.jpeg",
    category: "Sculpture",
    featured: false
  },
  {
    id: 39,
    title: "Jade Face",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/p1wtdm52_IMG_1005.jpeg",
    category: "Sculpture",
    featured: false
  },
  {
    id: 40,
    title: "Jade Ring",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/zl82d0sw_IMG_4157.jpeg",
    category: "Wearable Art",
    featured: false
  },
  {
    id: 41,
    title: "Jade Carving Detail",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/giqjfpdn_IMG_5550.jpeg",
    category: "Detail",
    featured: false
  },
  {
    id: 42,
    title: "Jade Collection",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/obfwczmz_IMG_9856.jpeg",
    category: "Collection",
    featured: true
  },
  {
    id: 43,
    title: "Translucent Jade",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/pc1ctutg_IMG_9755.jpeg",
    category: "Raw Stone",
    featured: false
  },
  {
    id: 44,
    title: "Jade Pendant Detail",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/nzqaj7r0_IMG_5935.jpeg",
    category: "Pendant",
    featured: false
  },
  {
    id: 45,
    title: "Jade Artifact",
    image: "https://customer-assets.emergentagent.com/job_artisancorner/artifacts/4yg5ddvo_IMG_1043.jpeg",
    category: "Sculpture",
    featured: false
  }
];

// The Sky Keys
const skyKeys = [
  {
    icon: Sparkles,
    title: "Sky Keys",
    description: "Perceptual configurations manifesting in stone, petroglyph, and natural pattern—unlocking vaults of Gaian wisdom in time-released form."
  },
  {
    icon: Mountain,
    title: "Gaian Consciousness",
    description: "Earth speaks not in human tongues, but through encoded symbols in the patterns of nature—the living mind revealing itself in visceral, symbolic codes."
  },
  {
    icon: Eye,
    title: "Morphic Resonance",
    description: "Rupert Sheldrake's hypothesis of invisible, nonlocal lattices of influence—shaping form and behavior across space and time like tuning forks in cosmic symphony."
  },
  {
    icon: Gem,
    title: "The Melong",
    description: "The sacred mirror reflecting phenomena without grasping—pure awareness wherein appearances arise and dissolve, the internal sky opened to merge with external cosmos."
  }
];

// Navigation Component
const Navigation = ({ scrolled }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`nav-container ${scrolled ? 'nav-scrolled' : ''}`} data-testid="navigation">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="font-cinzel text-xl tracking-widest"
        >
          <span className="text-[#00FF94]">VAJRA</span>STONE
        </motion.div>
        <motion.div 
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          className="hidden md:flex gap-8 font-mono text-xs tracking-wider"
        >
          {['gallery', 'themes', 'videos', 'custom-order', 'about'].map((section) => (
            <button
              key={section}
              onClick={() => scrollToSection(section)}
              className="text-[#A3A3A3] hover:text-[#00FF94] transition-colors duration-300 uppercase"
              data-testid={`nav-${section}`}
            >
              {section.replace('-', ' ')}
            </button>
          ))}
        </motion.div>
      </div>
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section className="hero-section" data-testid="hero-section">
      <div className="hero-bg" />
      <div className="mystical-gradient absolute inset-0" />
      
      <div className="relative z-10 text-center px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="font-mono text-xs tracking-[0.4em] text-[#00FF94] mb-4"
        >
          JADE ARTISTRY BY G.E. HALA ALDEBARAN
        </motion.p>
        
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="font-cinzel text-4xl sm:text-6xl md:text-8xl lg:text-9xl tracking-[0.1em] sm:tracking-[0.15em] mb-8"
        >
          VAJRA<span className="text-[#00FF94]">STONE</span>
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="font-manrope text-lg md:text-xl text-[#A3A3A3] max-w-xl mx-auto mb-12"
        >
          Nephrite Jade: the stone of heaven is all 5 elements in perfect harmony.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="hero-image-container mx-auto jade-glow"
        >
          <img 
            src={artworks[0].image}
            alt="Luminous Green Jade"
            className="hero-image w-full"
          />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="mt-16"
        >
          <ChevronDown className="w-8 h-8 text-[#00FF94] mx-auto animate-bounce" />
        </motion.div>
      </div>
    </section>
  );
};

// Gallery Section
const GallerySection = ({ onImageClick }) => {
  return (
    <section id="gallery" className="gallery-section" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        {/* PayPal Payment Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="font-manrope text-[#A3A3A3] mb-6">
            To make a payment or donation please click the link below
          </p>
          <a
            href="https://www.paypal.me/osirionjade?locale.x=en_US"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block group"
            data-testid="paypal-payment-btn"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_artisancorner/artifacts/5etolutw_IMG_0241.jpeg"
              alt="PayPal - Vajrastone"
              className="w-48 h-48 object-cover rounded-full mx-auto hover:scale-105 transition-transform duration-300 jade-glow"
            />
            <p className="font-mono text-sm text-[#00FF94] mt-4 group-hover:text-white transition-colors">
              PayPal.me/osirionjade
            </p>
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <p className="section-subtitle">Collection</p>
          <h2 className="section-title">The Gallery</h2>
          <div className="jade-divider" />
        </motion.div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {artworks.map((artwork, index) => (
            <motion.div
              key={artwork.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className={`gallery-item aspect-square ${artwork.featured ? 'md:col-span-2 md:row-span-2' : ''}`}
              onClick={() => onImageClick(artwork)}
              data-testid={`gallery-item-${artwork.id}`}
            >
              <img src={artwork.image} alt={artwork.title} loading="lazy" />
              <div className="gallery-overlay flex flex-col justify-end p-4 md:p-6">
                <p className="font-mono text-[10px] md:text-xs text-[#00FF94] tracking-wider mb-1">{artwork.category}</p>
                <h3 className="font-cinzel text-sm md:text-xl tracking-wide">{artwork.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Sky Key Themes Section
const ThemesSection = () => {
  return (
    <section id="themes" className="themes-section" data-testid="themes-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="section-subtitle">Philosophy</p>
          <h2 className="section-title">The Sky Keys</h2>
          <div className="jade-divider mx-auto" />
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {skyKeys.map((theme, index) => (
            <motion.div
              key={theme.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="theme-card"
              data-testid={`theme-card-${index}`}
            >
              <theme.icon className="w-10 h-10 text-[#00FF94] mb-4" />
              <h3 className="font-cinzel text-lg tracking-wider mb-3">{theme.title}</h3>
              <p className="font-manrope text-sm text-[#A3A3A3] leading-relaxed">{theme.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Link to full chapter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a
            href="/chapter-6"
            className="inline-flex items-center gap-3 px-6 py-3 border border-white/20 text-[#A3A3A3] hover:border-[#00FF94] hover:text-[#00FF94] transition-colors duration-300 font-mono text-sm tracking-wider"
            data-testid="read-chapter-link"
          >
            <BookOpen className="w-4 h-4" />
            Read Chapter 6: The Mind of Nature
          </a>
        </motion.div>
      </div>
    </section>
  );
};

// Video Section
const VideoSection = () => {
  return (
    <section id="videos" className="video-section" data-testid="video-section">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="section-subtitle">Process</p>
          <h2 className="section-title">The Craft</h2>
          <div className="jade-divider mx-auto" />
          <p className="font-manrope text-[#A3A3A3] mt-4 max-w-lg mx-auto">
            Watch the ancient art of jade carving come to life through skilled hands and sacred intention.
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="video-container relative"
          data-testid="video-container"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_artisancorner/artifacts/zxiv1d4i_IMG_9748.jpeg"
            alt="Video coming soon"
            className="w-full h-full object-cover opacity-50"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="video-play-btn opacity-50 cursor-default">
              <Play className="w-8 h-8 ml-1" />
            </div>
            <p className="font-cinzel text-2xl tracking-widest mt-6 text-[#00FF94]">COMING SOON</p>
            <p className="font-mono text-xs text-[#A3A3A3] mt-2 tracking-wider">Behind-the-scenes carving sessions</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

// Custom Order Form
const CustomOrderForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    description: '',
    budget: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create email body with order details
    const subject = `Custom Order Inquiry from ${formData.name}`;
    const body = `
CUSTOM ORDER INQUIRY
====================

Name: ${formData.name}
Email: ${formData.email}
Budget: ${formData.budget || 'Not specified'}

Vision/Description:
${formData.description}

====================
Sent from Vajrastone website
    `.trim();
    
    // Open email client with pre-filled details
    const mailtoLink = `mailto:nephrite77@icloud.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
    
    toast.success("Opening your email client to send the inquiry!");
  };

  return (
    <section id="custom-order" className="form-section" data-testid="custom-order-section">
      <div className="form-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="section-subtitle">Commission</p>
          <h2 className="section-title">Custom Orders</h2>
          <div className="jade-divider mx-auto" />
          <p className="font-manrope text-[#A3A3A3] mt-4">
            Fill out the form below to send a custom order inquiry directly to G.E. Hala Aldebaran.
          </p>
        </motion.div>
        
        <motion.form
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
          className="space-y-8"
          data-testid="custom-order-form"
        >
          <div>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
              className="input-minimal"
              data-testid="input-name"
            />
          </div>
          
          <div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              required
              className="input-minimal"
              data-testid="input-email"
            />
          </div>
          
          <div>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe your vision — symbols, meanings, size, style..."
              required
              rows={4}
              className="input-minimal resize-none"
              data-testid="input-description"
            />
          </div>
          
          <div>
            <input
              type="text"
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              placeholder="Budget Range (optional)"
              className="input-minimal"
              data-testid="input-budget"
            />
          </div>
          
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            className="btn-jade w-full"
            data-testid="submit-order-btn"
          >
            Send Inquiry via Email
          </motion.button>
        </motion.form>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section id="about" className="about-section" data-testid="about-section">
      <div className="about-content text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p className="section-subtitle">The Artist</p>
          <h2 className="section-title">G.E. Hala Aldebaran</h2>
          <p className="font-mono text-sm text-[#00FF94] tracking-wider mt-2">Osirion</p>
          <div className="jade-divider mx-auto mt-6" />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-8 space-y-6"
        >
          <p className="font-manrope text-lg text-[#A3A3A3] leading-relaxed">
            I have communed many times with the universal consciousness—the mind of nature—through encoded dialogues 
            that catalyzed the sky keys: perceptual configurations manifesting in stone, petroglyph, and natural pattern, 
            unlocking vaults of Gaian wisdom in time-released form.
          </p>
          <p className="font-manrope text-[#A3A3A3] leading-relaxed">
            For me, nephrite jade has become the primary conduit—its translucent emerald depths, cool and smooth to touch, 
            veined with subtle inclusions that catch light like captured starlight, carved vessels holding galactic gterma 
            (hidden treasure-teachings) sung by ancient stones. This is how I find them. Within the song—the jade is singing 
            to me—I only have to listen.
          </p>
          <p className="font-mono text-xs text-[#525252] tracking-wider mt-8">
            "The mind of nature pulses eternally alive—in nephrite's veiled emerald glow, in petroglyphs' etched song upon basalt, in Gaian breath scented with pine and renewal."
          </p>
          
          <div className="pt-8 mt-8 border-t border-white/10">
            <p className="font-mono text-xs text-[#A3A3A3] tracking-wider">
              With deep gratitude to my jade carving teachers
            </p>
            <p className="font-cinzel text-lg text-[#E5E5E5] mt-2 tracking-wide">
              Cheyenne Sunhill & Rockhead Rex
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="max-w-7xl mx-auto"
      >
        <h3 className="font-cinzel text-2xl tracking-[0.15em] mb-6">
          <span className="text-[#00FF94]">VAJRA</span>STONE
        </h3>
        
        <div className="flex flex-wrap justify-center gap-6 mb-8">
          <a 
            href="https://instagram.com/vajrastone" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#A3A3A3] hover:text-[#00FF94] transition-colors duration-300"
            data-testid="instagram-link"
          >
            <Instagram className="w-5 h-5" />
            <span className="font-mono text-sm">@Vajrastone</span>
          </a>
          <a 
            href="mailto:nephrite77@icloud.com"
            className="flex items-center gap-2 text-[#A3A3A3] hover:text-[#00FF94] transition-colors duration-300"
            data-testid="email-link"
          >
            <Mail className="w-5 h-5" />
            <span className="font-mono text-sm">Contact</span>
          </a>
          <a 
            href="https://www.paypal.me/osirionjade?locale.x=en_US"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#A3A3A3] hover:text-[#00FF94] transition-colors duration-300"
            data-testid="paypal-link"
          >
            <span className="font-mono text-sm">💎 Support via PayPal</span>
          </a>
        </div>
        
        <p className="font-mono text-xs text-[#525252]">
          © {new Date().getFullYear()} Vajrastone by G.E. Hala Aldebaran. All rights reserved.
        </p>
      </motion.div>
    </footer>
  );
};

// Lightbox Component
const Lightbox = ({ image, onClose }) => {
  return (
    <AnimatePresence>
      {image && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="lightbox"
          onClick={onClose}
          data-testid="lightbox"
        >
          <motion.img
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            src={image.image}
            alt={image.title}
            className="lightbox-image"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="lightbox-close" onClick={onClose} data-testid="lightbox-close">
            <X className="w-6 h-6" />
          </button>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="absolute bottom-8 left-0 right-0 text-center"
          >
            <p className="font-mono text-xs text-[#00FF94] tracking-wider mb-1">{image.category}</p>
            <h3 className="font-cinzel text-2xl tracking-wide">{image.title}</h3>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// Home Page Component
const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="noise-overlay" />
      <Toaster 
        position="bottom-right" 
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            color: '#E5E5E5',
          },
        }}
      />
      
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <GallerySection onImageClick={setSelectedImage} />
      <ThemesSection />
      <VideoSection />
      <CustomOrderForm />
      <AboutSection />
      <Footer />
      
      <Lightbox image={selectedImage} onClose={() => setSelectedImage(null)} />
    </>
  );
};

// Main App with Routes
function App() {
  return (
    <div className="App" data-testid="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chapter-6" element={<Chapter6 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
